<template>
  <EmailText size="2xl" weight="bold">
    <slot />
  </EmailText>
</template>
